<template>
    <div class="home-page">
        <RecentHackathons />
        <LatestProjects />
        <LatestComments />
        <LatestIdeas />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import RecentHackathons from '@/components/RecentHackathons';
import LatestComments from '@/components/LatestComments';
import LatestProjects from '@/components/LatestProjects';
import LatestIdeas from '@/components/LatestIdeas';
import '@/assets/images/page-not-found.svg';

export default {
    components: {
        RecentHackathons,
        LatestComments,
        LatestProjects,
        LatestIdeas,
    },

    data() {
        return {
            loading: true,
            collapseHeader: false,
            uploader: {
                progress: 0,
                file: null,
                interval: 0,
            },
        };
    },

    mounted() {
        if (!this.user?.uid) this.$router.replace({ name: 'login' });
    },

    computed: {
        ...mapState({
            isAdmin: ({ auth }) => auth.user.isAdmin,
            comments: ({ hackathons }) => hackathons.comments,
            user: ({ auth }) => auth.user,
            projects: ({ projects }) => projects.projects,
        }),

        ...mapGetters({
            activeHackathon: 'hackathons/getActiveHackathon',
        }),
    },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .home-page {
        display: flex;
        flex-direction: column;
        gap: $spacing-200;
    }
</style>
